import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import BasicUsage from './BasicUsage';
import ClientProvider from './client';
export default createDemo(import.meta.url, BasicUsage, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/styled/demos/basic-usage/BasicUsage.tsx",
    "fileName": "BasicUsage.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { styled } from '@mui/system';\n\nconst MyComponent = styled('div')({\n  color: 'darkslategray',\n  backgroundColor: 'aliceblue',\n  padding: 8, // will be converted to `8px`\n  borderRadius: 4, // will be converted to `4px`\n});\n\nexport default function BasicUsage() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <MyComponent>Styled div</MyComponent>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 14,
        "focusedLines": 1,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { styled } from '@mui/system';\n\nconst MyComponent = styled('div')({\n  color: 'darkslategray',\n  backgroundColor: 'aliceblue',\n  padding: 8, // will be converted to `8px`\n  borderRadius: 4, // will be converted to `4px`\n});\n\nexport default function BasicUsage() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <MyComponent>Styled div</MyComponent>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "MyComponent"
              ],
              ">Styled div</",
              [
                "span",
                "pl-c1 di-jsx",
                "MyComponent"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 14,
    "focusedLines": 1,
    "collapsible": true,
    "externals": [
      "@mui/system"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
